<ng-container *ngIf="variant === 'compact'">
  <ion-item
    mode="ios"
    lines="none"
    color="transparent"
    class="getm-search-no-results-compact"
  >
    <ion-img
      slot="start"
      [src]="image"
      class="getm-search-no-results-image-compact"
    ></ion-img>
    <ion-label class="getm-search-no-results-label-compact">
      <ion-text class="getm-search-no-results-title-compact">{{
        translatedTitle
      }}</ion-text>
      <ion-text class="getm-search-no-results-description-compact">{{
        translatedDescription
      }}</ion-text>
    </ion-label>
  </ion-item>
</ng-container>

<ng-container *ngIf="variant === 'fullscreen'">
  <ion-grid class="getm-search-no-results-fullscreen">
    <ion-row>
      <ion-col size="12" class="getm-search-no-results-content-fullscreen">
        <ion-img
          [src]="image"
          class="getm-search-no-results-image-fullscreen"
        ></ion-img>
        <ion-text class="getm-search-no-results-title-fullscreen">{{
          translatedTitle
        }}</ion-text>
        <ion-text class="getm-search-no-results-description-fullscreen">{{
          translatedDescription
        }}</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
